<template>
    <b-modal
        v-model="modal"
        :id="'rubric-row-heading-edit'"
        :title="$t('rubrics.edit_row')"
        @ok="onOk"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal rubric-row-heading-edit">
        <div class="rubric-row-heading-edit">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-if="error.error"
                    v-for="(error, index) in errors"
                    variant="danger"
                    show
                    :key="index">
                    {{ error.message }}
                </b-alert>
            </div>

            <div class="left-section">
                <b-form-group
                    class="rubric-row-heading-title-group"
                    :label="$t('common.title')"
                    label-for="rubric-row-heading-title-input">
                    <b-form-input
                        id="rubric-row-heading-title-input"
                        v-model="title"
                        :placeholder="$t('common.title')"></b-form-input>
                </b-form-group>

                <b-form-group
                    class="rubric-row-heading-order-group"
                    :label="$t('rubrics.position')"
                    label-for="rubric-row-heading-order-input">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="rubric-row-heading-order-input"
                        v-model="order"
                        :options="getRowsOrderList"></b-form-select>
                </b-form-group>
            </div>

            <div
                class="right-section"
                v-if="rubricShowAdvancedOptions">
                <b-form-group
                    class="rubric-row-heading-weight-group"
                    :label="$t('rubrics.weight')"
                    label-for="rubric-row-heading-weight-input">
                    <b-form-input
                        id="rubric-row-heading-weight-input"
                        v-model="weight"
                        :placeholder="$t('rubrics.weight')"></b-form-input>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-rubric-edit-row-heading-edit-row-modal-component',
    props: {
        rubricShowAdvancedOptions: Boolean,
    },

    data() {
        return {
            title: '',
            weight: 1,
            order: '',
            row: '',
            edit: false,
            showValues: 0,
            rubricRows: [],
            hasError: false,
            errors: {
                title: {
                    error: false,
                    message: this.$t('rubrics.the_title_field_cannot_be_empty'),
                },
                weigth: {
                    error: false,
                    message: this.$t('rubrics.the_field_value_does_not_contain_a_valid_number'),
                },
            },
            modal: false,
        };
    },

    methods: {
        clearFields() {
            this.hasError = false;
            this.errors.title.error = false;
            this.errors.weigth.error = false;
        },

        show(row, rows) {
            this.clearFields();
            this.row = row;
            this.rubricRows = rows;
            this.title = this.row.title;
            this.weight = this.row.weight;
            this.order = this.row.order;
            this.modal = true;
        },

        checkForErrors() {
            this.hasError = false;
            if (this.title === '') {
                this.hasError = true;
                this.errors.title.error = true;
            }

            if (isNaN(this.weight)) {
                this.hasError = true;
                this.errors.weigth.error = true;
            }

            return this.hasError;
        },

        onOk(bvModalEvt) {
            if (this.checkForErrors()) {
                bvModalEvt.preventDefault();
                return;
            }

            const data = {
                id: this.row.id,
                sectionId: this.row.section_id,
                title: this.title,
                weight: this.weight,
                order: this.order,
            };

            this.alert.saving();
            this.axios.post(this.routes.updateRubricRow(this.row.id), data).then(
                (response) => {
                    ords.hold();

                    this.row.update(response.data.row);

                    for (const row of response.data.newRows) {
                        ords.use('rubricRow').update({ order: row.order }, row.id);
                    }

                    ords.continue();

                    this.clearFields();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    computed: {
        getRowsOrderList() {
            let orders = [];
            if (this.rubricRows.length) {
                orders = this.rubricRows.map((order) => {
                    return {
                        value: order.order,
                        text: order.order,
                        disabled: order.order === this.row.order,
                    };
                });
                orders.sort((a, b) => (a.value > b.value ? 1 : -1));
            }
            return orders;
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .rubric-row-heading-edit {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;

        .errors {
            flex: 1 0 100%;
        }

        .left-section {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
            width: calc(75% - 15px);

            .rubric-row-heading-title-group {
                width: calc(75% - 15px);
            }

            .rubric-row-heading-order-group {
                width: calc(25% - 15px);
            }

            &:last-child {
                width: 100%;
            }
        }

        .right-section {
            align-self: flex-start;
            width: calc(25% - 15px);
        }
    }
}
</style>
